import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Console } from 'console';
import moment from 'moment';
import 'moment-timezone';
import * as timezoneJS from 'moment-timezone';
import { CodeList } from 'src/app/models/basicMeetingModel';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { UserService } from 'src/app/service/user.service';
import { MustMatch } from '../password-creation/must-match.validator';
import { environment, environment_msg } from 'src/environments/environment';
import { AgoraConfigService } from 'src/AgoraConfigService';
@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css']
})
export class ProfilePageComponent implements OnInit, AfterViewInit {
  securityQuetsionForm !: UntypedFormGroup;
  isSubmitted = false;
  setSecQuesValue: any = ["doyoulikereadingbooks", "company", "favouritecolour", "doyoulikereadingbooks", ""];
  userData: any;
  tzNames: any;
  profileTimeZoneNames!: CodeList;
  questionPolicyLength: any;
  userDetails: any;
  securityQuestionData: any;
  questionToRetain: any = [];
  secQuesValues: any = [];
  secQuesResponse: any;
  answeredSecQues: any = [];
  ansQues: any = [];
  jitsiUrl = new UntypedFormControl('');
  usersCalendarValue: any;
  calendarTypes: any;
  questIdReq: String = "";
  validSecQues: any;
  emptyFormArray = new UntypedFormArray([]);
  zoomIntegration = new UntypedFormGroup({
    zoomEmail: new UntypedFormControl('', [Validators.required, Validators.email])
  });
  isZoomDisabled = true;
  encSecUserId: any;
  agoraConfigObject: any;
  constructor(public notifiy: NotifierService, private formBuilder: UntypedFormBuilder, public userService: UserService, public meetingService: MeetingService, public globals: Globals, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;

    var zoomReqJson = {
      "fkSecUserId": localStorage.getItem("userId"),
      "webConfType": "Zoom"
    }

    this.userService.checkUserWebConfExists(zoomReqJson).subscribe((data: any) => {

      this.zoomIntegration.controls['zoomEmail'].setValue(data.body.webConfEmail);
      this.encSecUserId = data.body.encSecUserId;
      if (data.body.isUserAuthorized) {
        this.isZoomDisabled = true;
        this.zoomIntegration.controls['zoomEmail'].disable();
      }
      else {
        this.isZoomDisabled = false;
      }
    });

    //service to fetch usersCalender
    this.userService.fetchUsersCalendar(localStorage.userId).subscribe((data: any) => {
      this.usersCalendarValue = data.body

    });

    //service for biographical information
    this.userService.getUserDetails(localStorage.userId).subscribe((data: any) => {
      this.userData = data.body

      this.setBiographicalInformation();
    });
    this.meetingService.fetchTimeZoneName().then((timeZoneResp: any) => {
      this.profileTimeZoneNames = timeZoneResp
      this.tzNames = timeZoneResp

    });
    this.meetingService.fetchCalendarTYpe().then((timeZoneResp: any) => {
      this.profileTimeZoneNames = timeZoneResp
      this.calendarTypes = timeZoneResp


    });
    //Service for security questions
    var reqJson = { "loginName": localStorage.loginName, "orgCode": localStorage.orgCode, "newPasswordFlag": "0" };
    this.userService.fetchPasswordDetails(reqJson).subscribe((data: any) => {
      this.securityQuestionData = data.body;
      this.secQuesResponse = this.securityQuestionData.secQuesList;
      this.answeredSecQues = this.securityQuestionData.answeredSecQuesList;
      this.questionPolicyLength = Number(this.securityQuestionData.noOfSecQuesConf);
      var formArray = new UntypedFormArray([])

      this.answeredSecQues.forEach((element: any, index: any) => {
        var ques = {
          "questionId": element[0],
          "questions": element[1],
          "answers": ""
        }
        this.ansQues.push(ques);
      });

      for (var i = 0; i < this.questionPolicyLength; i++) {
        if (this.ansQues[i] != undefined || this.ansQues[i] != null) {
          formArray.push(this.formBuilder.group({
            "questionId": this.ansQues[i].questionId,
            "questions": { value: this.ansQues[i].questions, disabled: true },
            "answers": ""
          }))
        } else {
          formArray.push(this.formBuilder.group({
            "questionId": '',
            "questions": '',
            "answers": ""
          }))
        }
      }
      this.securityQuetsionForm.setControl("questionContainer", formArray);
      /* this.ansQues.forEach((element:any,index :any) => {
         formArray.push(this.formBuilder.group({
           "questionId":element.questionId,
           "questions": element.questions,
           "answers": ""
         }))        
       });
       if(formArray.length<this.questionPolicyLength){
    
           for(var i=formArray.length;i<this.questionPolicyLength;i++){
        
             formArray.push(this.formBuilder.group({
               "questionId":'',
               "questions": "",
               "answers": ""
             }))  
           }
       }
      
       
       
     /* if(this.securityQuetsionForm.controls['questionContainer'].value.length < 5){
       for(let i = 5; i >= this.securityQuetsionForm.controls['questionContainer'].value.length; i--){
         let fg = this.createEmpFormGroup();
         this.employees.push(fg);
      
       }
     }*/
      //let fg = this.createEmpFormGroup();
      //this.employees.push(fg);

      /*for(let i = 0; i < this.questionPolicyLength; i++){
        let fg = this.createEmpFormGroup();
        this.employees.push(fg);
   
      }*/

    });


  }
  ngAfterViewInit(): void {

    //   this.securityQuetsionForm.setControl("questionContainer",formArray);
  }
  passwordPolicyMap(arg0: string, passwordPolicyMap: any) {
    throw new Error('Method not implemented.');
  }

  get employees(): UntypedFormArray {
    return this.securityQuetsionForm.get('questionContainer') as UntypedFormArray;
    //return this.emptyFormArray;
  }

  ngOnInit(): void {
    this.securityQuetsionForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]],
      questionContainer: this.formBuilder.array([this.createEmpFormGroup()]),
    });

  }


  changeTracker(event: any, id: any) {

    if (this.questionToRetain.length == 0) {
      this.questionToRetain.push(event.value)

    }
    else if ((this.questionToRetain[id] == event.value) == false) {

      this.questionToRetain[id] = event.value
      // this.questionToRetain.push(event.value)

    }

  }
  disabledSelectedItems(event: any) {
    let checker;
    if (this.questionToRetain.length) {
      for (let i = 0; i < this.questionToRetain.length; i++) {
        if (this.questionToRetain[i] == event) {
          checker = true
          // return true;
        }
      }
    }
    return checker;
  }
  get f() {
    return this.securityQuetsionForm.controls;
  }

  createEmpFormGroup() {
    return this.formBuilder.group({
      questionId: [''],
      questions: [''],
      answers: [''],
    })
  }

  personalCalendar = new UntypedFormGroup({
    userMail: new UntypedFormControl(''),
    calendarType: new UntypedFormControl('', Validators.required)

  });

  bioGraphicalInformation = new UntypedFormGroup({
    firstName: new UntypedFormControl('', Validators.required),
    lastName: new UntypedFormControl('', Validators.required),
    phno: new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
    timeszone: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    userIsActive: new UntypedFormControl(''),
    jobType: new UntypedFormControl(''),
    loginName: new UntypedFormControl(''),
    bioGraphicalFlag: new UntypedFormControl('')

  });
  setBiographicalInformation() {

    this.bioGraphicalInformation.controls['firstName'].setValue(this.userData.userFirstname);
    this.bioGraphicalInformation.controls['lastName'].setValue(this.userData.userLastname);
    this.bioGraphicalInformation.controls['phno'].setValue(this.userData.userPhone);
    this.bioGraphicalInformation.controls['email'].setValue(this.userData.userEmail);
    this.bioGraphicalInformation.controls['jobType'].setValue(localStorage.jobType);
    this.bioGraphicalInformation.controls['timeszone'].setValue(localStorage.timeszone);
    this.bioGraphicalInformation.controls['userIsActive'].setValue(this.userData.userIsactive);
    this.bioGraphicalInformation.controls['loginName'].setValue(localStorage.loginName);
    this.bioGraphicalInformation.controls['bioGraphicalFlag'].setValue('Y')
    this.jitsiUrl.setValue(this.userData.jitsi_url);
    this.personalCalendar.controls['userMail'].setValue(this.usersCalendarValue.userName);
    this.personalCalendar.controls['calendarType'].setValue(this.usersCalendarValue.calendarType);

  }

  fetchUserCalInfo() {


    var reqJson = {
      "userId": localStorage.userId,
      "calendarType": this.personalCalendar.controls['calendarType'].value,
      "orgCode": localStorage.orgCode
    }

    this.userService.fetchCalendarInfo(reqJson).subscribe((data: any) => {

      this.personalCalendar.controls['userMail'].setValue(data.body.userName);

    });

    if (this.personalCalendar.controls['calendarType'].value == 'OUTLOOK' && this.globals.settingValuesList.validateAppVal == 'false') {
      let ele = <HTMLInputElement>document.getElementById('username')
      ele.setAttribute('disabled', 'true')
    }
  }
  timeZoneValue(tz: any) {

  }
  saveEditProfile() {
    if (this.bioGraphicalInformation.invalid) {
      this.notifiy.show({
        type: 'error',
        message: environment_msg.msg_error_mandatory_fields
      });
      return;
    }
    this.userService.saveEditProfile(this.bioGraphicalInformation.value).subscribe((data: any) => {
      var resp = data.body
      this.notifiy.show({
        type: 'success',
        message: environment_msg.msg_success_data_saved
      });
      this.globals.vTimeZone = resp.timeszone;
      localStorage.removeItem('timeszone');
      localStorage.setItem('timeszone', this.globals.vTimeZone);

      this.globals.vShortTimeZone = resp.userShortTzName;
      localStorage.removeItem('userShortTzName')
      localStorage.setItem('userShortTzName', this.globals.vShortTimeZone);

    });
  }
  saveSecQues() {
    this.secQuesValues.pop();
    this.secQuesValues = [];
    this.questIdReq = "";
    this.ansQues.forEach((element: any, index: any) => {
      this.questIdReq += element.questionId + ":" + element.questions + ","

    });

    /*if(this.ansQues.length < 5){
  
       for(var i=5;i>this.ansQues.length;i--){
    
       this.questIdReq += "0"+":"+"0"+",";
       }
   }*/
    for (let i = 0; i < this.employees.length; i++) {

      var eachQuesJson = {
        "quesCode": this.employees.at(i).get('questions')?.value,
        "quesAnswer": this.employees.at(i).get('answers')?.value
      };
      this.secQuesValues.push(eachQuesJson);
    }
    for (var j = 0; j < this.secQuesValues.length; j++) {
      if (this.secQuesValues[j].quesAnswer == '') {
        this.validSecQues = j;
      }
    }

    var secQuesJson = {
      "oldPassword": this.securityQuetsionForm.controls['password'].value,
      "secQuesString": JSON.stringify(this.secQuesValues),
      "secQuesFlag": "Y",
      "loginName": localStorage.loginName,
      "selectedQuestionArrayHidFP": this.questIdReq,
      "noOfSecQuesConfHidFP": this.securityQuestionData.noOfSecQuesConf,
    }

    if (this.securityQuetsionForm.controls['password'].value != '' && this.securityQuetsionForm.controls['password'].value != null) {
      this.userService.saveEditProfile(secQuesJson).subscribe((data: any) => {
        this.questIdReq = "";

        this.notifiy.show({
          type: 'success',
          message: environment_msg.msg_success_data_saved
        });

      })
    } else if (this.validSecQues == 4) {

      this.notifiy.show({
        type: 'error',
        message: environment_msg.msg_error_enter_one_answer
      });
    } else {
      this.notifiy.show({
        type: 'error',
        message: environment_msg.msg_error_enter_password
      });
    }
  }

  newPasswordForm = new UntypedFormGroup({

    oldPassword: new UntypedFormControl('', [Validators.required]),
    // oldPassword : ['',[Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]],
    newPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]),
    confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]),


  });

  saveNewPassword() {

    var reqJson = {
      "loginName": localStorage.loginName,
      "oldPassword": this.newPasswordForm.controls['oldPassword'].value,
      "password": this.newPasswordForm.controls['confirmPassword'].value,
      "changePasswordFlag": 1
    }
    if (this.newPasswordForm.invalid || reqJson.oldPassword == "" || reqJson.password == "") {
      this.isSubmitted = false;
      this.notifiy.show({
        type: 'error',
        message: environment_msg.msg_error_password_cannot_empty
      });
      return;
    }

    this.userService.updatePasswordDetails(reqJson).subscribe((data: any) => {
      this.userDetails = data.body;

      if (this.userDetails.errorMessage != undefined && this.userDetails.errorMessage !== null && this.userDetails.errorMessage != "") {
        this.notifiy.show({
          type: 'error',
          message: this.userDetails.errorMessage
        });
      } else {
        this.notifiy.show({
          type: 'success',
          message: environment_msg.msg_success_password_changed_success
        });
      }
    });
  }

  saveWebPreference() {

    var json = {
      "userId": localStorage.userId,
      "jitsi_url": this.jitsiUrl.value
    }


    this.userService.updateWebPref(localStorage.userId, json).subscribe((data: any) => {
      if (data.jitsi_url == null && data.jitsi_url == undefined) {
        this.notifiy.show({
          type: 'success',
          message: environment_msg.msg_success_data_saved
        });
      }
    });

  }

  savePersonalCalendar() {
    if (this.personalCalendar.invalid) {
      this.notifiy.show({
        type: 'error',
        message: environment_msg.msg_error_select_calendar_type
      });
      return;
    }

    var json = {
      "userName": this.personalCalendar.controls['userMail'].value,
      "calendarType": this.personalCalendar.controls['calendarType'].value,
      "userId": localStorage.userId
    }

    this.userService.updatePersonalCalendar(localStorage.userId, json).subscribe((data: any) => {

      this.notifiy.show({
        type: 'success',
        message: environment_msg.msg_success_data_saved
      });

    });
  }

  changeDetection(e: any, j: any) {
    /*
       this.questIdReq="";
  
       this.ansQues[j].questions = e.quesCode
  
       this.ansQues.forEach((element:any,index:any) => {
       this.questIdReq += element.questionId+":"+ element.questions+","
   
       });
       if(this.ansQues.length <= this.securityQuestionData.noOfSecQuesConf){
    
         for(var i=this.securityQuestionData.noOfSecQuesConf;i>this.ansQues.length;i--){
      
         this.questIdReq += "0"+":"+"0"+",";
       }
     } */



  }

  connectZoom() {
    // if(this.zoomIntegration.controls['zoomEmail'].valid){
    var zoomEmail = this.zoomIntegration.get('zoomEmail')?.value;
    // this.router.navigate(['/zoomOAuth'])
    var reqJSON = {
      "pk_userid": localStorage.getItem('userId'),
      "orgCode": localStorage.getItem('orgCode'),
      "webConfType": "Zoom",
      "fkSecUserId": localStorage.getItem("userId"),
      "createdBy": localStorage.getItem("userId")
    }

    this.userService.saveUserWebConf(reqJSON).subscribe(response => {
      var closeWindow = window.open(this.agoraConfigObject.zoomAuthorizeEndpointURL + "&state=" + this.encSecUserId, "_blank");
      window.addEventListener('message', (event) => {
        if (event.data === 'success') {
          // Refresh parent window
          var zoomReqJson = {
            "fkSecUserId": localStorage.getItem("userId"),
            "webConfType": "Zoom"
          }

          this.userService.checkUserWebConfExists(zoomReqJson).subscribe((data: any) => {

            this.zoomIntegration.controls['zoomEmail'].setValue(data.body.webConfEmail);
            this.encSecUserId = data.body.encSecUserId;
            if (data.body.isUserAuthorized) {
              this.isZoomDisabled = true;
              this.zoomIntegration.controls['zoomEmail'].disable();
            }
            else {
              this.isZoomDisabled = false;
            }
          });
          //location.reload();
        }
      });
    });


  }

  public checkError = (controlName: string, errorName: string) => {
    return this.zoomIntegration.controls[controlName].hasError(errorName);
  }

}
